import { initializeApp } from "firebase/app";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { initAuthStateListener } from "./utils/authState";
import AsyncComputed from "vue-async-computed";
import Ads from "vue-google-adsense";

Vue.use(AsyncComputed);
Vue.use(require("vue-script2"));
Vue.use(Ads.Adsense);

Vue.config.productionTip = false;

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA12uoQQVCQyXdMJfFoi1R48GKww88CaO4",
  authDomain: "project-rankster.firebaseapp.com",
  databaseURL: "https://project-rankster.firebaseio.com",
  projectId: "project-rankster",
  storageBucket: "project-rankster.appspot.com",
  messagingSenderId: "490483734391",
};

initializeApp(firebaseConfig);
initAuthStateListener();

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
